import getChosenAccessories from './getChosenAccessories'

const calculateTotal = (items, shippingPrice, freeShippingTotal) => {
  let subtotal = 0
  let shipping = 0
  let total = 0
  let isFreeShipping = false

  if (items.length === 0) {
    return false
  }

  items.forEach(item => {
    const { quantity, price } = item
    subtotal += Number(quantity) * Number(price)

    if ('accessories' in item && 'chosenAccessories' in item) {
      if (item.accessories && item.chosenAccessories) {
        const chosenAccessories = getChosenAccessories(item.accessories, item.chosenAccessories)

        chosenAccessories.forEach(a => {
          const { price } = a
          subtotal += Number(quantity) * Number(price)
        })
      }
    }
  })

  if (subtotal >= freeShippingTotal) {
    isFreeShipping = true
    shipping = 0
  } else {
    shipping = shippingPrice
  }

  total = Number(subtotal) + Number(shipping)

  return {
    subtotal,
    shipping,
    total,
    isFreeShipping,
  }
}

export default calculateTotal
